import {
  Button,
  IconButton,
  Dialog,
} from '@mui/material';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import StopIcon from '@mui/icons-material/Stop';
import TimeElapsed from './subcomponents/TimeElapsed';
import ButtonWithSpinner from '../../buttons/ButtonWithSpinner';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './AudioRecorder.scss';

const defaultProps = {
  open: false,
  onClose: () => { },
  isRecording: false,
  startRecording: () => { },
  stopRecording: () => { },
  recordedAudioUrl: null,
  onApply: () => { },
  isSaving: false,
  limitInMinute: null,
};

/**
 * A component for Audio recorder ui
 */
export default function AudioRecorder(props) {
  const {
    open,
    onClose,
    isRecording,
    startRecording,
    stopRecording,
    recordedAudioUrl,
    onApply,
    isSaving,
    limitInMinute,

  } = { ...defaultProps, ...filterUndefined(props) };
  const getStartRecordingComponent = () => (
    <>
      <IconButton
        className='audio-recorder-start-recording-action'
        onClick={() => { startRecording(); }}
        disabled={isSaving}
        aria-label='Start Audio Recording'
      >
        <FiberManualRecordRoundedIcon className='icon-red-with-gradient-boder audio-recorder-icon-no-margin' />
      </IconButton>
      <div className='audio-recorder-time-elapsed-label' />
    </>
  );

  const getStopRecordingComponent = () => (
    <>
      <IconButton
        className='audio-recorder-stop-recording-action'
        onClick={() => { stopRecording(); }}
      >
        <StopIcon className='audio-recorder-icon' />
      </IconButton>
      <div className='audio-recorder-time-elapsed-label'>
        <TimeElapsed />
      </div>
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className='audio-recorder-backdrop'
    >
      <div
        className='audio-recorder'
        data-test='audio-recorder-dialog'
      >
        <div className='audio-recorder-title'>Audio Recorder</div>
        {limitInMinute !== null ? (
          <div className='audio-recorder-title'>
            Audio length is limited to&nbsp;
            {limitInMinute}
            &nbsp;minutes.
          </div>
        ) : ''}
        <div className='audio-recorder-content'>
          {
          isRecording ? getStopRecordingComponent() : getStartRecordingComponent()
          }
          <div className='audio-recorder-audio-player'>
            <audio controls src={recordedAudioUrl} aria-label='Audio Player'>
              <track kind='captions' />
            </audio>
          </div>
        </div>
        <div className='audio-recorder-action'>
          <Button
            onClick={onClose}
            className='btn-gray-background audio-recorder-button vizzle-audio-recorder-cancel-btn'
            disabled={isRecording || isSaving}
            aria-label='Close Audio Recorder'
          >
            Close
          </Button>
          <ButtonWithSpinner
            onClick={onApply}
            loading={isSaving}
            className='btn-primary audio-recorder-button vizzle-audio-recorder-apply-btn'
            disabled={isRecording || !recordedAudioUrl}
            label='Apply'
            aria-label='Apply Audio Recording'
          />
        </div>
      </div>
    </Dialog>
  );
}
